/*@ngInject*/
const ApplicationController = function ($rootScope, $scope, $location, $state, $timeout, coreConstant, appTypeConfigurationModel, coreMediator, userStateModel, localization, persistentConnection, uiPerformanceLogger, notificationPopupUtil, authenticationUtil, refreshLoginTokenUtil) {

    let bootstrapRedirect,
        timeoutList = [],
        notificationLoadingBarPromise = null,
        notificationLoadingBarScope = null;

    $scope.appIsReady = false;

    function goToLoginPage() {
        $scope.appIsReady = true;

        if ($state.current.name !== 'password' && !$location.search().token) {

            if (!bootstrapRedirect) {
                bootstrapRedirect = $location.url();

                if (_.startsWith(bootstrapRedirect, '/login') || bootstrapRedirect === '') {
                    bootstrapRedirect = null;
                }
            }

            coreMediator.disconnect();
            $state.go('login', {
                username: $location.search().username,
                login: $location.search().login,
                externalToken: $location.search().externalToken
            });
        }
    }

    function setAvailableToChat() {
        let visibleForChat = true;

        coreMediator.setChatVisibility(visibleForChat).then(function () {
            userStateModel.setVisibleForChat(visibleForChat);
        });
    }

    function bootstrapApplication(skipRedirection) {
        //as soon as logged in, set available to chat to true
        setAvailableToChat();

        coreMediator.bootstrapApplication().then(function () {
            $scope.appIsReady = true;

            if (!skipRedirection) {
                if (bootstrapRedirect) {
                    $location.url(bootstrapRedirect);
                    bootstrapRedirect = null;
                } else {
                    $state.go('landing');
                }
            }
        });
    }

    $scope.$on(coreConstant.event.BOOT_APPLICATION, function () {
        bootstrapApplication();
    });

    $scope.$on(coreConstant.event.INVALID_SESSION, function () {
        // Remove the login details if there was an invalid session error, as this may indicate the token has
        // expired.
        coreMediator.removeLoginToken();
        coreMediator.removeClientId();

        refreshLoginTokenUtil.stop();

        goToLoginPage();
    });

    $scope.$on(coreConstant.event.START_UI_PERFORMANCE_LOG, function (event, logAction, message) {
        uiPerformanceLogger.startLog(logAction, message);
    });

    $scope.$on(coreConstant.event.END_UI_PERFORMANCE_LOG, function (event, logAction, status, newMessage, isLogOut) {
        uiPerformanceLogger.endLog(logAction, status, newMessage, isLogOut);
    });

    $scope.$on(coreConstant.event.END_UI_PERFORMANCE_LOG_WITHOUT_LOGGING, function (event, logAction) {
        uiPerformanceLogger.endLogWithoutLogging(logAction);
    });

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.isPrintPreview = toState.name.indexOf('print') !== -1;
    });

    $scope.$on(coreConstant.event.CREATE_NOTIFICATION, function (event, notification) {
        timeoutList.push($timeout(function () {
            // Note that multiple notifications can fire within the timeout of a notification, causing an update to the notification
            // attached to the scope.
            // Therefore care must be taken by the underlying controller to perform a one-time binding of the passed notification
            $scope.notification = notification;
            notificationPopupUtil.displayChatNotification($scope);
        }.bind(this), 0));
    }.bind(this));

    $scope.$on(coreConstant.event.SHOW_FADING_NOTIFICATION, function (event, notification) {
        timeoutList.push($timeout(function () {
            $scope.notification = notification;
            notificationPopupUtil.displayNotificationPopup($scope);
        }, 0));
    });

    $scope.$on(coreConstant.event.SHOW_FADING_NOTIFICATION_LOADING_BAR, function (event, notification) {
        notificationLoadingBarScope = $rootScope.$new(true);
        notificationLoadingBarScope.notification = notification;
        notificationLoadingBarScope.isLoadingBar = true;

        notificationLoadingBarPromise = notificationPopupUtil.displayNotificationPopup(notificationLoadingBarScope);
    });

    $scope.$on(coreConstant.event.CONCLUDE_FADING_NOTIFICATION_LOADING_BAR, function (event, notification) {
        if (!_.isNil(notificationLoadingBarScope)) {
            notificationLoadingBarScope.notification = notification;
            notificationLoadingBarScope.isLoadingBar = false;
        }
    });

    $scope.$on(coreConstant.event.HIDE_FADING_NOTIFICATION_LOADING_BAR, function (event, isHard) {
        if (!_.isNil(notificationLoadingBarPromise)) {
            notificationLoadingBarPromise.then(function (notification) {
                notification.kill(isHard);
            });
            notificationLoadingBarPromise = null;
        }
    });

    $scope.$on('$destroy', function () {
        _.each(timeoutList, function (item) {
            $timeout.cancel(item);
        });
    });

    localization.getTranslations().then(function () {
        authenticationUtil.attemptAutoAuthentication().then(bootstrapApplication, goToLoginPage);
    });
};

angular.module('ums')
    .controller('applicationController', ApplicationController);
